var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    stroke: "#FF8A79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.63397C12.1667 7.01887 12.1667 7.98113 11.5 8.36603L6.25 11.3971C5.58333 11.782 4.75 11.3009 4.75 10.5311L4.75 4.46891C4.75 3.69911 5.58333 3.21799 6.25 3.60289L11.5 6.63397Z",
    fill: "#FF8A79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play_btn.9a4f19738693908a0baa349e465534f3.svg";
export { ForwardRef as ReactComponent };